import { Pipe, PipeTransform } from '@angular/core';

const RATIO_M_FT = 3.28084;
const RATIO_FEETS_MILE = 5280;

@Pipe({
  name: 'distance',
  standalone: true,
})
export class DistancePipe implements PipeTransform {
  transform(distanceMeter: number, ...options): string {
    if (isNaN(distanceMeter)) {
      return null;
    }

    const isImperial: boolean = options.includes('imperial');
    if (options.includes('value')) {
      return '' + this.getDistanceValue(distanceMeter, isImperial);
    }
    if (options.includes('unit')) {
      return this.getDistanceUnit(distanceMeter, isImperial);
    }
  }

  private getDistanceValue(distanceMeter: number, isImperial: boolean): number {
    if (isImperial) {
      return this.getDistanceValueImperial(distanceMeter * RATIO_M_FT);
    }
    return this.getDistanceValueMetric(distanceMeter);
  }

  private getDistanceValueImperial(distanceFeets: number): number {
    if (distanceFeets < RATIO_FEETS_MILE) {
      return Math.floor(distanceFeets);
    }
    const distanceMiles = parseFloat(
      (distanceFeets / RATIO_FEETS_MILE).toFixed(1)
    );
    return distanceMiles;
  }

  private getDistanceValueMetric(distanceMeter: number): number {
    if (distanceMeter < 1000) {
      return Math.floor(distanceMeter);
    }
    const distanceKm = parseFloat((distanceMeter / 1000).toFixed(1));
    return distanceKm;
  }

  private getDistanceUnit(distanceMeter: number, isImperial: boolean): string {
    if (isImperial) {
      return this.getDistanceUnitImperial(distanceMeter * RATIO_M_FT);
    }
    return this.getDistanceUnitMetric(distanceMeter);
  }

  private getDistanceUnitImperial(distanceFeets: number): string {
    if (distanceFeets < RATIO_FEETS_MILE) {
      return 'ft';
    }
    return 'mi';
  }

  private getDistanceUnitMetric(distanceMeter: number): string {
    if (distanceMeter < 1000) {
      return 'm';
    }
    return 'km';
  }
}
